export default "__VITE_ASSET__Cn5pYQLM__"